// removed by extract-text-webpack-plugin
module.exports = {"curatedCards":"curatedCards--j3QBn"};